import { BasketErrorModel, DEFAULT_ERROR_TEXT } from 'models/Errors';

export function errorToBasketErrorModel(error: Error, source: string): BasketErrorModel {
    if (error instanceof BasketErrorModel) {
        return error;
    }

    let basketError = new BasketErrorModel(DEFAULT_ERROR_TEXT);
    basketError.source = source;

    basketError.stack = error.stack;
    basketError.logMessage = error.message;

    return basketError;
}